import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TenantProfileResolve } from '../../view-gallery/resolves/tenant-profile.resolve';

export const tenantProfilePageTitleResolver: ResolveFn<string> = () => {
  const re = inject(TenantProfileResolve);

  return re.resolve().then(tenant => {
    if (!tenant) return 'Galleries';
    return `${tenant.name}`;
  });
};
